import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { isApiError } from "@/lib/api/errors";
import { ThemeProvider, useTheme } from "./providers/ThemeProvider";
import { AppRouter } from "./router/AppRouter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Retry transient failures only; 4xx answers will not change on retry.
      retry: (failureCount, error) => failureCount < 2 && (!isApiError(error) || error.status === 0 || error.status >= 500),
    },
    mutations: { retry: false },
  },
});

function ThemedToasts() {
  const { resolved } = useTheme();
  return <ToastContainer position="top-right" theme={resolved} newestOnTop closeOnClick pauseOnFocusLoss={false} autoClose={4500} />;
}

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
        <ThemedToasts />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
